<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    lock-scroll
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="greater"
    @close="$_cancle"
  >
    <div class="content" v-loading="isLoading">
      <el-form ref="modify" :rules="rules" label-position="right" :model="formData">
        <el-form-item label="所属菜单:">
          <el-input :value="menuItem.name" disabled class="form-item__input"></el-input>
        </el-form-item>
        <el-form-item label="按钮名称:" prop="name">
          <el-input v-model="formData.name" placeholder="必填" class="form-item__input"></el-input>
          <span class="input-tips">*必填，2-15个中文字符长度，格式不限</span>
        </el-form-item>
        <el-form-item label="按钮编码:" prop="code">
          <el-input v-model="formData.code" placeholder="必填" class="form-item__input"></el-input>
          <span class="input-tips">*必填</span>
        </el-form-item>
        <el-form-item label="是否显示:">
          <el-select v-model="formData.status" class="form-item__selector">
            <el-option
              v-for="item in statusArr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button class="save__btn" @click="$_submit">确认</el-button>
      <el-button class="cancel__btn" @click="$_cancle">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getStrLength } from "@/plugins/utils";
export default {
  name: "modify-button",
  props: ["title", "formType", "menuItem", "buttonObj"],
  data() {
    const validStr = (rule, value, callback) => {
      if (getStrLength(value) < 4 || getStrLength(value) > 30) {
        callback(new Error("长度为2-15个中文字符长度"));
      } else {
        callback();
      }
    };
    return {
      visible: false,
      isLoading: false,
      statusArr: [
        { value: 1, label: "显示" },
        { value: 2, label: "不显示" }
      ],
      formData: {
        bid: 0,
        name: "",
        code: "",
        status: 1
      },
      rules: {
        name: [
          { required: true, message: "请输入按钮名称", trigger: "blur" },
          { validator: validStr, trigger: "blur" }
        ],
        code: [{ required: true, message: "请输入按钮编码", trigger: "blur" }]
      }
    };
  },
  methods: {
    $_cancle() {
      this.visible = false;
      this.$emit("close");
    },
    $_submit() {
      if (this.isLoading) return false;
      this.isLoading = true;
      this.$refs["modify"].validate(valid => {
        if (valid) {
          let actionName = "addButton";
          let functionId = this.menuItem.fid;
          let { bid, name, code, status } = this.formData;
          let postData = {
            functionId,
            name,
            code,
            status
          };
          if (bid > 0) {
            actionName = "editButton";
            Object.assign(postData, { bid });
          }
          let _this = this;
          this.$service.post(actionName, postData).then(result => {
            this.isLoading = false;
            if (result.$.checkResult(result, true)) {
              $MessageBox.alert({
                content: result.msg,
                onOk() {
                  _this.visible = false;
                  _this.$emit("callback");
                }
              });
            }
          });
        } else {
          this.isLoading = false;
        }
      });
    }
  },
  created() {
    if (this.formType === "edit") {
      for (const [key, value] of Object.entries(this.buttonObj)) {
        if (this.formData.hasOwnProperty(key)) {
          this.formData[key] = value;
        }
      }
    }
  },
  mounted() {
    this.visible = true;
  }
};
</script>
<style lang="scss" scoped>
.content {
  height: 100%;
  padding: 30px;
}
.input-tips {
  margin-left: 10px;
}
.form-item {
  &__input {
    width: 440px;
  }
  &__selector {
    width: 200px;
  }
}
</style>
